import { IMapper } from '@/mappers/index'
import {
  IAccounts,
  IAccountsResponse,
  ICreatePersonalAccount,
  ICreatePersonalAccountResponse,
  IGroupPersonalAccount,
  IGroupPersonalAccountResponse,
  IPersonalAccountImportGisGkh,
  IPersonalAccountImportGisGkhResponse
} from '@/types/personal-accounts'
import { accrualsMap } from '@/mappers/accruals'

export const importPersonalAccountGisGkhMap: IMapper<IPersonalAccountImportGisGkhResponse, IPersonalAccountImportGisGkh> = {
  moid: 'moid',
  data: 'data',
  file: 'file'
}

export const accountsMap: IMapper<IAccountsResponse, IAccounts> = {
  account_external_id: 'accountExternalId',
  account_global_id: 'accountGlobalId',
  account_holder: 'accountHolder',
  created_at: 'createdAt',
  deleted_at: 'deletedAt',
  extra: 'extra',
  house_id: 'houseId',
  id: 'id',
  last_accrual: ['lastAccrual', accrualsMap],
  information_source: 'informationSource',
  property_address: 'propertyAddress',
  updated_at: 'updatedAt'
}

export const personalAccountMap: IMapper<IGroupPersonalAccountResponse, IGroupPersonalAccount> = {
  house_id: 'houseId',
  personal_accounts: ['personalAccounts', accountsMap],
  string_address: 'stringAddress',
  short_address: 'shortAddress'
}

export const createPersonalAccountMap: IMapper<ICreatePersonalAccountResponse, ICreatePersonalAccount> = {
  id: 'id',
  moid: 'moid',
  account_global_id: 'accountGlobalId',
  account_holder: 'accountHolder',
  house_id: 'houseId',
  property_address: 'propertyAddress'
}
